import { RegexBasedPasswordPolicy } from './RegexBasedPasswordPolicy';

export class MustContainSymbolsPolicy extends RegexBasedPasswordPolicy {

    private static instance: MustContainSymbolsPolicy = new MustContainSymbolsPolicy();

    private constructor() {
        super(/[-!@$%^&*()_+|~=`{}\[\]:";'<>?,.\/#]/);
    }

    public static getPolicy(): MustContainSymbolsPolicy {
        return MustContainSymbolsPolicy.instance;
    }
}
